const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const OpsSchool = require("./vault/OpsSchool");
const SortableTable = require("./SortableTable");
const Link = require("../core/view/Link");
const URLMake = require("../../shared/URLMake");
const ClassesUtil = require("./util/ClassesUtil");
const EditPencil = require("../office/EditPencil");
const CopyTable = require("./data/CopyTable");

const styles = require("./styles/StaffTables.css");

module.exports = createReactClass({
	displayName: "StaffTables",

	propTypes: {
		user: PT.object.isRequired,
		pageData: PT.object,
		schoolState: PT.object.isRequired,
		showModal: PT.func,
	},

	getSchoolsAndClassesForStaff: function(
		schoolState,
		staff,
		staffType,
		purchaseYear
	) {
		let schools, classes;
		if (staffType === "teacher") {
			const allClasses = OpsSchool.getClassesForTeacher(schoolState, staff.id);
			schools = OpsSchool.getSchoolsForTeacher(schoolState, staff.id);
			const currClasses = _.filter(allClasses, c => c.year === purchaseYear);
			classes = !currClasses.length ? allClasses : currClasses;
		} else if (staffType === "auditor") {
			schools = OpsSchool.getSchoolsForAuditor(schoolState, staff.id);
			// Auditors don't have classes, there is no auditClassIDs
			classes = [];
		}
		return {schools, classes};
	},

	getStaffData: function(schoolState, staff, isPurchaseActive, staffType) {
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		return staff.map(t => {
			const linkTo = URLMake.forUserAccount(t.id);
			const displayName = ClassesUtil.getUserName(t);
			const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
			const {schools, classes} = this.getSchoolsAndClassesForStaff(
				schoolState,
				t,
				staffType,
				purchaseYear
			);
			const resolvedActive = OpsSchool.isStaffResolvedActive(schoolState, t.id);
			const isActive = resolvedActive && isPurchaseActive;
			const hasPerms =
				_.includes(
					["schoolAdmin", "purchaseAdmin", "partialAdmin"],
					OpsSchool.getBestRoleForStaff(
						schoolState,
						this.props.user.userID,
						t.id
					)
				) || t.id === this.props.user.userID;

			const baseData = {
				name: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: t.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{displayName}
						</Link>
					</div>
				),
				nameValue: displayName,
				email: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: t.id,
										type: "email",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<div className={styles.email}>{t.newEmail || t.email}</div>
					</div>
				),
				emailValue: t.newEmail || t.email,
				school: ClassesUtil.getListDisplay(schools),
				class: ClassesUtil.getListDisplay(classes),
				inactive: !isActive,
			};

			return baseData;
		});
	},

	getAuditorData: function(schoolState, auditors, isPurchaseActive) {
		return this.getStaffData(
			schoolState,
			auditors,
			isPurchaseActive,
			"auditor"
		);
	},

	getTeacherData: function(schoolState, teachers, isPurchaseActive) {
		return this.getStaffData(
			schoolState,
			teachers,
			isPurchaseActive,
			"teacher"
		);
	},

	getSaData: function(schoolState, schoolAdmins, isPurchaseActive) {
		const {user, pageData} = this.props;
		const {schoolID} = pageData;
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		return schoolAdmins.map(sa => {
			const linkTo = URLMake.forUserAccount(sa.id);
			const displayName = ClassesUtil.getUserName(sa);
			const schools = OpsSchool.getSchoolsForAdmin(schoolState, sa.id);
			let schoolText = _.get(schools, "0.displayName", "");
			if (schools.length > 1) {
				schoolText += " +" + (schools.length - 1);
			}
			const resolvedActive = OpsSchool.isStaffResolvedActive(
				schoolState,
				sa.id
			);
			const isActive = resolvedActive && isPurchaseActive;
			const hasPerms = _.includes(
				["schoolAdmin", "purchaseAdmin", "partialAdmin"],
				OpsSchool.getBestRoleForStaff(
					schoolState,
					this.props.user.userID,
					sa.id
				)
			);
			const hasPermsSchool = _.includes(
				["schoolAdmin", "purchaseAdmin"],
				OpsSchool.getBestRoleForStaff(
					schoolState,
					this.props.user.userID,
					sa.id
				)
			);
			const canEdit = sa.id !== user.userID;
			return {
				name: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: sa.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{displayName}
						</Link>
					</div>
				),
				nameValue: displayName,
				email: (
					<div className={styles.editable}>
						{isActive && hasPerms && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: sa.id,
										type: "email",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{sa.newEmail || sa.email}
					</div>
				),
				emailValue: sa.newEmail || sa.email,
				school: schoolText,
				// Can only remove from a single school at a time.
				remove:
					schoolID && hasPermsSchool && canEdit ? (
						<div className={styles.remove}>
							<span
								onClick={() =>
									this.props.showModal("confirmInfo", {
										type: "remove",
										userID: sa.id,
										schoolID,
										role: "schoolAdmin",
									})
								}
							>
								Remove as admin from school
							</span>
						</div>
					) : null,
				inactive: !isActive,
			};
		});
	},

	getPurchaseAdminData: function(purchaseAdmins, isPurchaseActive) {
		const {user, schoolState} = this.props;
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		const activePAs = _.filter(purchaseAdmins, pa =>
			OpsSchool.isStaffResolvedActive(schoolState, pa.id)
		);
		return purchaseAdmins.map(pa => {
			const linkTo = URLMake.forUserAccount(pa.id);
			const displayName = ClassesUtil.getUserName(pa);
			const resolvedActive = OpsSchool.isStaffResolvedActive(
				schoolState,
				pa.id
			);
			const inactiveText =
				isPurchaseActive && !resolvedActive ? "Inactive" : null;
			const isActive = isPurchaseActive && resolvedActive;
			const canEdit = pa.id !== user.userID;
			return {
				name: (
					<div className={styles.editable}>
						{isActive && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: pa.id,
										type: "name",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						<Link to={linkTo} className={styles.link}>
							{displayName}
						</Link>
					</div>
				),
				nameValue: displayName,
				email: (
					<div className={styles.editable}>
						{isActive && !isAcademy ? (
							<EditPencil
								onClick={() =>
									this.props.showModal("updateInfo", {
										userID: pa.id,
										type: "email",
									})
								}
								className={styles.pencil}
							/>
						) : (
							<div className={styles.pencil} />
						)}
						{pa.newEmail || pa.email}
					</div>
				),
				emailValue: pa.newEmail || pa.email,
				// Cannot remove if only one purchase Admin
				remove:
					activePAs.length > 1 && resolvedActive && canEdit && !isAcademy ? (
						<div className={styles.remove}>
							<span
								onClick={() =>
									this.props.showModal("confirmInfo", {
										type: "remove",
										userID: pa.id,
										role: "purchaseAdmin",
									})
								}
							>
								Remove as admin
							</span>
						</div>
					) : (
						inactiveText
					),
			};
		});
	},

	headerClasses: {
		name: styles.name,
	},

	widthClasses: {
		name: styles.nameWidth,
		email: styles.emailWidth,
		school: styles.schoolWidth,
		class: styles.classWidth,
		remove: styles.removeWidth,
		status: styles.removeWidth,
	},

	renderEmptyTable: function(type, scope) {
		const emptyTableText = CopyTable.getEmptyTableCopy(type, scope);
		const textMap = {
			student: "Students",
			teacher: "Teachers",
			schoolAdmin: "School Admins",
		};
		return (
			<div className={styles.empty}>
				<div className={styles.emptyTitle}>
					{textMap[type] || _.capitalize(type)}
				</div>
				{emptyTableText}
			</div>
		);
	},

	render: function() {
		const {pageData, schoolState, showModal, user} = this.props;
		const {schoolID} = pageData;

		const isPurchaseActive = OpsSchool.isPurchaseActive(schoolState);
		const isSingleSchool = _.get(
			schoolState,
			"accounts.purchase.isSingleSchool"
		);
		const isAcademy = OpsSchool.isAcademyPurchase(schoolState);
		const isPurchaseAdmin = OpsSchool.isPurchaseAdmin(schoolState, user.userID);
		const isSchoolAdmin = OpsSchool.isSchoolAdmin(schoolState, user.userID);
		let hasPerms = isPurchaseAdmin || isSchoolAdmin;
		if (schoolID) {
			hasPerms = _.includes(
				["schoolAdmin", "purchaseAdmin", "partialAdmin"],
				OpsSchool.getBestRoleForSchool(
					schoolState,
					this.props.user.userID,
					schoolID
				)
			);
		}
		let isActive = isPurchaseActive;
		let purchaseAdminTable;
		let schoolAdmins = [];
		let teachers = [];
		let teacherCols;
		let teacherHeaderVal;
		let auditorCols;
		let auditorHeaderVal;
		let auditors = [];
		let scope;

		const sortFunctions = {
			name: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.nameValue)),
				]);
			},
			email: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.emailValue)),
				]);
			},
			school: body => {
				return _.sortBy(body, [
					"inactive",
					r => _.toLower(_.trim(r.schoolValue || r.school)),
				]);
			},
		};
		if (!schoolID || isSingleSchool) {
			if (isPurchaseAdmin) {
				// Purchase Admins
				const purchaseAdmins = OpsSchool.getPurchaseAdmins(schoolState);
				// There should always be at least one purchase admin
				const adminCols = ["name", "email", "remove"];
				const paHeaderVal = [
					isSingleSchool ? "School Admins" : "System Admins",
					"Email",
					"",
				];
				purchaseAdminTable = (
					<SortableTable
						columnNames={adminCols}
						sortableColumns={_.without(adminCols, "remove")}
						headers={_.zipObject(adminCols, paHeaderVal)}
						initiallySortedBy="name"
						data={this.getPurchaseAdminData(purchaseAdmins, isPurchaseActive)}
						sortFunctions={sortFunctions}
						evenRowDark={true}
						canScroll={true}
						headerClasses={this.headerClasses}
						widthClasses={this.widthClasses}
						grayOutInactive={true}
					/>
				);
				schoolAdmins = OpsSchool.getAllSchoolAdmins(schoolState);
				teachers = _.uniqBy(
					OpsSchool.getAllTeachers(schoolState, true),
					t => t.id
				);
				auditors = _.uniqBy(
					OpsSchool.getAllAuditors(schoolState, true),
					a => a.id
				);
			} else if (isSchoolAdmin) {
				// School Admins
				const adminSchools = OpsSchool.getSchoolsForAdmin(
					schoolState,
					user.userID
				);
				schoolAdmins = _.uniqBy(
					_.flatMap(adminSchools, s =>
						OpsSchool.getAdminsForSchool(schoolState, s.id)
					),
					sa => sa.id
				);
				teachers = _.uniqBy(
					_.flatMap(adminSchools, s =>
						OpsSchool.getTeachersForSchool(schoolState, s.id)
					),
					sa => sa.id
				);
				auditors = _.uniqBy(
					_.flatMap(adminSchools, s =>
						OpsSchool.getAuditorsForSchool(schoolState, s.id)
					),
					a => a.id
				);
			}
			teachers = _.uniqBy(teachers, t => t.id);
			auditors = _.uniqBy(auditors, a => a.id);

			// Hide inactive auditors who are still active teachers.
			// They'll appear in the Teachers table instead.
			auditors = auditors.filter(a => {
				const isCurrentAuditor =
					a.current?.auditPurchase || a.current?.auditSchoolIDs?.length;
				const isCurrentTeacher = a.current?.teachClassIDs?.length > 0;
				// Show if they're a current auditor, or if they're not a current teacher
				return isCurrentAuditor || !isCurrentTeacher;
			});

			teacherCols = ["name", "email", "school", "class"];
			teacherHeaderVal = ["Teachers", "Email", "School", "Class"];
			auditorCols = ["name", "email", "school"];
			auditorHeaderVal = ["Auditors", "Email", "School"];
			scope = isSingleSchool ? "school" : "district";
		} else {
			isActive = OpsSchool.isSchoolActive(schoolState, schoolID);
			schoolAdmins = OpsSchool.getAdminsForSchool(schoolState, schoolID);
			teachers = OpsSchool.getTeachersForSchool(schoolState, schoolID);
			auditors = OpsSchool.getAuditorsForSchool(schoolState, schoolID);
			teacherCols = ["name", "email", "class"];
			teacherHeaderVal = ["Teachers", "Email", "Class"];
			auditorCols = ["name", "email", "school"];
			auditorHeaderVal = ["Auditors", "Email", "School"];
			scope = "school";
		}
		const saCols = ["name", "email", "school", "remove"];
		const saHeaderVal = ["School Admins", "Email", "School", ""];
		let schoolAdminTable;
		// Single schools will only have purchase admin table. Single schools will
		// not be able to add school admins, only purchase admins (which will be
		// called "school admins" to the school user).
		if (!isSingleSchool) {
			schoolAdminTable = schoolAdmins.length ? (
				<SortableTable
					columnNames={saCols}
					sortableColumns={_.without(saCols, "remove")}
					headers={_.zipObject(saCols, saHeaderVal)}
					initiallySortedBy="name"
					data={this.getSaData(schoolState, schoolAdmins, isPurchaseActive)}
					sortFunctions={sortFunctions}
					evenRowDark={true}
					canScroll={true}
					headerClasses={this.headerClasses}
					widthClasses={this.widthClasses}
					grayOutInactive={true}
				/>
			) : (
				this.renderEmptyTable("schoolAdmin", scope)
			);
		}

		const teachersTable = teachers.length ? (
			<SortableTable
				columnNames={teacherCols}
				sortableColumns={teacherCols}
				headers={_.zipObject(teacherCols, teacherHeaderVal)}
				initiallySortedBy="name"
				data={this.getTeacherData(schoolState, teachers, isPurchaseActive)}
				sortFunctions={sortFunctions}
				evenRowDark={true}
				canScroll={true}
				headerClasses={this.headerClasses}
				widthClasses={this.widthClasses}
				grayOutInactive={true}
			/>
		) : (
			this.renderEmptyTable("teacher", scope)
		);

		const auditorsTable = auditors.length ? (
			<SortableTable
				columnNames={auditorCols}
				sortableColumns={auditorCols}
				headers={_.zipObject(auditorCols, auditorHeaderVal)}
				initiallySortedBy="name"
				data={this.getAuditorData(schoolState, auditors, isPurchaseActive)}
				sortFunctions={sortFunctions}
				evenRowDark={true}
				canScroll={true}
				headerClasses={this.headerClasses}
				widthClasses={this.widthClasses}
				grayOutInactive={true}
			/>
		) : (
			this.renderEmptyTable("auditor", scope)
		);

		let paTable;
		if (purchaseAdminTable) {
			paTable = (
				<div className={styles.table}>
					{purchaseAdminTable}
					{isActive && !isAcademy ? (
						<div
							className={styles.add}
							onClick={() => showModal("addInfo", "purchaseAdmin")}
						>
							Add {isSingleSchool ? "School Admin" : "System Admin"}
						</div>
					) : null}
				</div>
			);
		}

		return (
			<div className={styles.main}>
				{paTable}
				<div className={styles.table}>
					{schoolAdminTable}
					{isActive && schoolAdminTable && hasPerms && !isAcademy ? (
						<div
							className={styles.add}
							onClick={() => showModal("addInfo", "schoolAdmin")}
						>
							Add School Admin
						</div>
					) : null}
				</div>
				<div className={styles.table}>
					{teachersTable}
					{isActive && hasPerms && !isAcademy ? (
						<div
							className={styles.add}
							onClick={() => showModal("addInfo", "teacher")}
						>
							Add New Teacher
						</div>
					) : null}
				</div>
				<div className={styles.table}>{auditorsTable}</div>
			</div>
		);
	},
});
